module.exports = __webpack_public_path__ + "img/ic_position_server.5a7294a3.png";